module.exports = __webpack_public_path__ + "img/6_136.2710f3d6.png";